/**
 * ferr.ts — Categoría "Ferretería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_ferr",
  skuPrefix: "FER",
  categoria: "Ferretería",
} as const;

export const cat_ferr_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Taladro Percutor Bosch",
    marca: "Bosch",
    modelo: "GSB 13 RE",
    origen: "Malasia",
    costo: 185000,
    precio: 289000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Estante F1",
    proveedor: "Bosch Colombia",
    garantia: "1 año",
    material: "Metal y plástico",
    colorProducto: "Verde/negro",
    descripcionLarga:
      "Taladro percutor 600W, chuck 13mm, velocidad variable con reversa. Ideal concreto, metal y madera.",
    especificaciones: [
      { clave: "Potencia", valor: "600W" },
      { clave: "Chuck", valor: "13mm" },
    ],
    imageKeywords: ["drill", "bosch-drill", "power-tool"],
    color: "bg-green-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Caja Herramientas 108pzs",
    marca: "Stanley",
    modelo: "Maletín Pro",
    origen: "EE.UU.",
    costo: 285000,
    precio: 439000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "set",
    ubicacionFisica: "Estante F1",
    proveedor: "Stanley Black & Decker",
    garantia: "Vitalicia",
    material: "Acero cromado y plástico",
    descripcionLarga:
      "Juego 108 herramientas: llaves, destornilladores, copas, hexagonales y accesorios. Maletín organizador reforzado.",
    especificaciones: [
      { clave: "Piezas", valor: "108" },
      { clave: "Material llaves", valor: "Acero Cr-V" },
    ],
    imageKeywords: ["tool-set", "stanley-toolbox", "toolkit"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Martillo Uña 16 oz",
    marca: "Stanley",
    modelo: "Fatmax Antivibe",
    origen: "EE.UU.",
    costo: 32500,
    precio: 49900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante F2",
    proveedor: "Stanley Black & Decker",
    garantia: "Vitalicia",
    material: "Acero forjado + mango vinilo",
    descripcionLarga:
      "Martillo uña 16oz con mango ergonómico Antivibe reduce 70% vibración. Cabeza acero forjado templado.",
    especificaciones: [
      { clave: "Peso", valor: "16oz" },
      { clave: "Mango", valor: "Antivibe" },
    ],
    imageKeywords: ["hammer", "stanley-hammer", "claw-hammer"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Set Destornilladores 6pzs",
    marca: "Stanley",
    origen: "EE.UU.",
    costo: 38500,
    precio: 59900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "set",
    ubicacionFisica: "Estante F2",
    proveedor: "Stanley Black & Decker",
    garantia: "Vitalicia",
    material: "Acero Cr-V y plástico",
    descripcionLarga:
      "Set 6 destornilladores mixtos (plano y estrella) con mango bimaterial antideslizante. Puntas imantadas.",
    especificaciones: [
      { clave: "Piezas", valor: "6" },
      { clave: "Puntas", valor: "Imantadas" },
    ],
    imageKeywords: ["screwdriver-set", "tools", "stanley-tools"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Escalera Aluminio 6 Peldaños",
    marca: "Truper",
    modelo: "EST-6",
    origen: "México",
    costo: 185000,
    precio: 289000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Estante F3",
    proveedor: "Truper Colombia",
    garantia: "1 año",
    material: "Aluminio",
    dimensiones: "1.8m altura",
    descripcionLarga:
      "Escalera tipo tijera 6 peldaños, soporta hasta 100kg. Bandeja porta-herramientas y patas antideslizantes.",
    especificaciones: [
      { clave: "Altura", valor: "1.8m" },
      { clave: "Carga máx", valor: "100kg" },
    ],
    imageKeywords: ["ladder", "aluminum-ladder", "step-ladder"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Cinta Métrica 5m",
    marca: "Stanley",
    modelo: "PowerLock",
    origen: "EE.UU.",
    costo: 18500,
    precio: 28900,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "unidad",
    ubicacionFisica: "Estante F2",
    proveedor: "Stanley Black & Decker",
    garantia: "Vitalicia",
    material: "Plástico ABS + acero",
    descripcionLarga:
      "Cinta métrica 5m x 19mm, sistema bloqueo PowerLock, caja antigolpes y clip cinturón.",
    especificaciones: [
      { clave: "Longitud", valor: "5m" },
      { clave: "Ancho cinta", valor: "19mm" },
    ],
    imageKeywords: ["measuring-tape", "stanley-tape", "tape-measure"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Candado Yale 50mm",
    marca: "Yale",
    modelo: "Y110",
    origen: "Italia",
    costo: 48500,
    precio: 74900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Estante F4",
    proveedor: "Yale Colombia",
    garantia: "5 años",
    material: "Latín cromado",
    descripcionLarga:
      "Candado latún macizo cromado 50mm, arco 8mm templado anti-corte. Incluye 3 llaves.",
    especificaciones: [
      { clave: "Ancho", valor: "50mm" },
      { clave: "Llaves", valor: "3" },
    ],
    imageKeywords: ["padlock", "yale-lock", "security-lock"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Pintura Látex Blanco 1Gal",
    marca: "Pintuco",
    modelo: "Vinilo Lavable",
    origen: "Colombia",
    costo: 85000,
    precio: 129000,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "galón",
    ubicacionFisica: "Estante F5",
    pesoNeto: "3.8L",
    proveedor: "Pintuco S.A.",
    vencimientoMeses: 36,
    descripcionLarga:
      "Pintura vinilo látex lavable blanco mate. Alto poder cubriente, libre de olor. Rinde 40m²/galón 2 manos.",
    especificaciones: [
      { clave: "Volumen", valor: "1 galón (3.8L)" },
      { clave: "Rendimiento", valor: "40m² 2 manos" },
    ],
    imageKeywords: ["paint", "white-paint", "wall-paint"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Cemento Gris 50kg",
    marca: "Argos",
    modelo: "Cemento Uso General",
    origen: "Colombia",
    costo: 28500,
    precio: 43900,
    stock: 80,
    stockMinimo: 20,
    stockMaximo: 160,
    unidad: "bolsa",
    ubicacionFisica: "Bodega F6",
    pesoNeto: "50kg",
    proveedor: "Cementos Argos S.A.",
    vencimientoMeses: 2,
    descripcionLarga:
      "Cemento gris tipo I uso general 50kg. Ideal para concreto, morteros y construcciones estructurales.",
    especificaciones: [
      { clave: "Peso", valor: "50kg" },
      { clave: "Tipo", valor: "I Uso general" },
    ],
    imageKeywords: ["cement", "construction-cement", "argos"],
    color: "bg-slate-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Guantes Trabajo Nitrilo",
    marca: "Ansell",
    modelo: "HyFlex",
    origen: "Malasia",
    costo: 12500,
    precio: 19900,
    stock: 80,
    stockMinimo: 20,
    stockMaximo: 160,
    unidad: "par",
    ubicacionFisica: "Estante F4",
    proveedor: "Ansell Colombia",
    material: "Nitrilo + nylon",
    colorProducto: "Gris/negro",
    talla: "L",
    descripcionLarga:
      "Guantes ergonómicos con revestimiento nitrilo. Excelente agarre y destreza. Resistentes abrasión y cortes nivel 1.",
    especificaciones: [
      { clave: "Talla", valor: "L" },
      { clave: "Material", valor: "Nitrilo/nylon" },
    ],
    imageKeywords: ["work-gloves", "safety-gloves", "nitrile-gloves"],
    color: "bg-slate-700",
    shape: "square",
  }),
];
